const HEADER_HEIGHT = 96; // 56 + 40
const CONTAINER_PADDING = 16;
const SEARCH_BAR = 46; // 34 + 12
const LEFT_PANEL = CONTAINER_PADDING + 360;

export const autoPlacementPopover = (markerElement: HTMLElement) => {
  const popoverEl = markerElement.querySelector(
    '[data-popover]'
  ) as HTMLElement;
  if (!popoverEl) return;

  const markerRect = markerElement.getBoundingClientRect();
  const popoverRect = popoverEl.getBoundingClientRect();
  const popoverWidth = popoverRect.width || 384;
  const popoverHeight = popoverRect.height || 135;

  const safeArea = {
    top: HEADER_HEIGHT + CONTAINER_PADDING + SEARCH_BAR,
    left: LEFT_PANEL,
    right: window.innerWidth - CONTAINER_PADDING,
    bottom: window.innerHeight - CONTAINER_PADDING,
  };

  const isMarkerInSafeArea =
    markerRect.top >= safeArea.top &&
    markerRect.bottom <= safeArea.bottom &&
    markerRect.left >= safeArea.left &&
    markerRect.right <= safeArea.right;

  if (!isMarkerInSafeArea) {
    popoverEl.style.display = 'none';
    return;
  }

  const canDisplay = {
    top:
      markerRect.top - popoverHeight >= safeArea.top &&
      markerRect.left + popoverWidth / 2 <= safeArea.right &&
      markerRect.left - popoverWidth / 2 >= safeArea.left,

    right:
      markerRect.right + popoverWidth <= safeArea.right &&
      markerRect.top - popoverHeight / 2 >= safeArea.top &&
      markerRect.bottom + popoverHeight / 2 <= safeArea.bottom,

    left:
      markerRect.left - popoverWidth >= safeArea.left &&
      markerRect.top - popoverHeight / 2 >= safeArea.top &&
      markerRect.bottom + popoverHeight / 2 <= safeArea.bottom,

    bottom:
      markerRect.bottom + popoverHeight <= safeArea.bottom &&
      markerRect.left + popoverWidth / 2 <= safeArea.right &&
      markerRect.left - popoverWidth / 2 >= safeArea.left,
  };

  popoverEl.classList.remove(
    'bottom-full',
    'left-full',
    'right-full',
    'center-x',
    'center-y',
    'pb-3',
    'pt-3',
    'pl-3',
    'pr-3'
  );

  if (canDisplay.right) {
    popoverEl.classList.add('center-y', 'absolute', 'left-full', 'pr-3');
    popoverEl.style.display = '';
  } else if (canDisplay.left) {
    popoverEl.classList.add('center-y', 'absolute', 'right-full', 'pl-3');
    popoverEl.style.display = '';
  } else if (canDisplay.bottom) {
    popoverEl.classList.add('center-x', 'absolute', 'top-full', 'pt-3');
    popoverEl.style.display = '';
  } else if (canDisplay.top) {
    popoverEl.classList.add('center-x', 'absolute', 'bottom-full', 'pb-3');
    popoverEl.style.display = '';
  } else {
    popoverEl.style.display = 'none';
  }
};
